import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Drug } from "src/app/core/models/drug";
import { HttpService } from "src/app/core/service/http.service";
import { UserIdleService } from "angular-user-idle";

@Injectable({
  providedIn: "root",
})
export class PrescriptionService {
  constructor(
    private httpService: HttpService,
    private userIdle: UserIdleService
  ) {
    this.restart();
  }

  GetPrescriptionList(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetPrescriptionByFilter",
      prescriptionDetails
    );
  }

  CreatePrescription(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/CreatePrescription",
      prescriptionDetails
    );
  }

  DeletePrescription(prescriptionDetails: any) {
    return this.httpService.post("prescription/Delete", prescriptionDetails);
  }
  UpdatePrescription(prescriptionDetails: any) {
    return this.httpService.post("prescription/Update", prescriptionDetails);
  }
  ChangePrescriptionStatus(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/ChangeStatus",
      prescriptionDetails
    );
  }
  GetForWaitingRoom() {
    return this.httpService.getAnonymous(
      "prescription/GetPrescriptionForWaitingRoom"
    );
  }
  GetReplaceItems(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetReplaceDrugPrescriptionId",
      prescriptionDetails
    );
  }
  UpdatePrescriptionObj(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/UpdatePrescription",
      prescriptionDetails
    );
  }
  DownloadPrescription(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/downloadprescription",
      prescriptionDetails
    );
  }

  GetPharmacistDashboardPrescriptionList() {
    var prescriptionDetails = {
      pharmacyId: 1,
    };
    return this.httpService.post(
      "prescription/GetPrescriptionForPharmacistDashboard",
      prescriptionDetails
    );
  }

  GetPhysicianReport(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetPhysicianReport",
      prescriptionDetails
    );
  }
  GetPatientReport(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetPatientReport",
      prescriptionDetails
    );
  }
  GetDrugReport(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetDrugReport",
      prescriptionDetails
    );
  }
  GetPrescriptionCode(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/GetPrescriptionCode",
      prescriptionDetails
    );
  }
  GetActivityReport(prescriptionDetails: any) {
    return this.httpService.post(
      "activity/GetActivityReport",
      prescriptionDetails
    );
  }
  NotCollectedPrescription(prescriptionDetails: any) {
    return this.httpService.post(
      "prescription/NotCollectedPrescription",
      prescriptionDetails
    );
  }
  GetFavoriteDrugs(prescriptionDetails: any): any {
    return this.httpService.post(
      "pharmacyapi/GetFavoriteDrug",
      prescriptionDetails
    );
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
